import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'
import PageReactivate from '@/pages/account/reactivate'

export const Route = createFileRoute('/app/account/reactivate')({
  beforeLoad: ({ context }) => {
    requireAuth(context)
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <PageReactivate />
}
